angular.module('gettext').run(['gettextCatalog', function (gettextCatalog) {
/* jshint -W100 */
    gettextCatalog.setStrings('pl', {"E-mail":"E-mail","Login Form":"Logowanie","Login form":"Proszę się zalogować","Password":"Hasło","Sign in":"Zaloguj się","This is required!":"Pole wymagane!"});
/* jshint +W100 */
}]);


//////////////////
// WEBPACK FOOTER
// ./locale/pl.po
// module id = 1123
// module chunks = 1